import { FC, useCallback, useMemo, useRef } from 'react';
import { Link } from 'types/api.types';
import { Connection } from 'types/profile';
import { StickyTable } from 'app/components/Core/StickyTable/StickyTable';
import { Row } from '@tanstack/react-table';
import { useTotalWidth } from 'app/components/Core/StickyTable';
import { ConnectionsTableRow } from './ConnectionsTableRow';
import { getColumns } from './utils';

export interface ConnectionsListComponentProps {
  onConnect: (providerId: string) => Promise<void>;
  onDisconnect: (
    disconnectLink: Link,
    guid: string,
    name: string,
    providerId: string
  ) => Promise<void>;
  connections: Connection[];
  loading: boolean;
}

export const ConnectionsListComponent: FC<ConnectionsListComponentProps> = ({
  onConnect,
  onDisconnect,
  connections = [],
  loading,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const tableKey = 'profile-connections';
  const totalWidth = useTotalWidth(ref);
  const columns = useMemo(() => getColumns(totalWidth), [totalWidth]);

  const rowRenderer = useCallback(
    (row: Row<Connection>) => (
      <ConnectionsTableRow
        key={row.id}
        row={row}
        onConnect={onConnect}
        onDisconnect={onDisconnect}
      />
    ),
    [onConnect, onDisconnect]
  );

  return (
    <StickyTable<Connection>
      tableKey={tableKey}
      ref={ref}
      data={connections}
      columns={columns}
      rowRenderer={rowRenderer}
      loading={loading}
      data-testid="connections-list"
    />
  );
};
